import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import PropertyFactory from "../../Entity/Factories/PropertyFactory";
import UnitFactory from "../../Entity/Factories/UnitFactory";
import SubscriptionFactory from "../../Entity/Factories/SubscriptionFactory";
import { SubscriptionInterface } from "../../Entity/Entities/Subscription/SubscriptionInterface";
import { ActionInterface } from "../../Interface/ActionInterface";
import { PropertyInterface } from "../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../Entity/Entities/Unit/UnitInterface";
import Translator from "../../Translation/Translator";

export default function* propertyCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_PROPERTY_CREATE_CLEAR
    });

    yield put({
      type: Constants.PAGE_PROPERTY_CREATE_REQUEST
    });

    const res = yield call(Http.post, "properties", action.payload?.property);
    const property: PropertyInterface = PropertyFactory.create(res.data.property);

    yield put({
      type: Constants.PAGE_PROPERTY_CREATE_SUCCESS,
      payload: {
        property: property
      }
    });

    const subscription: SubscriptionInterface = SubscriptionFactory.create(res.data.subscription);

    if (!!res.data.property.units[0]) {
      const unit: UnitInterface = UnitFactory.create(res.data.property.units[0]);

      yield put({
        type: Constants.GLOBAL_UNIT_CREATE_SUCCESS,
        payload: {
          unit: unit
        }
      });
    }

    yield put({
      type: Constants.GLOBAL_SUBSCRIPTION_CREATE_SUCCESS,
      payload: {
        subscription: subscription
      }
    });

    if (!action.payload?.hideSnackbar) {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          type: "success",
          message: Translator.trans("snackbar-message-property-created-successfully")
        }
      });
    }

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, property);
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_PROPERTY_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPropertyCreate() {
  yield takeEvery(Constants.PAGE_PROPERTY_CREATE_START, propertyCreate);
}
